import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, ArrowRight, Download, Linkedin, MessageCircle, FileText, Package } from 'lucide-react';

const LOGO_URL = "/sawariya-logo.png";

const WHATSAPP_NUMBER = "919896557781";
const LINKEDIN_URL = "https://www.linkedin.com/company/sawariya-global-exports";

export const Footer = () => {
  return (
    <>
      {/* Floating WhatsApp + LinkedIn */}
      <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3" data-testid="floating-social">
        <a
          href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hi%20Sawariya%20Global%20Exports%2C%20I%27m%20interested%20in%20a%20rice%20export%20enquiry.`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-float"
          aria-label="Chat on WhatsApp"
          className="group w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-2xl hover:scale-110 hover:shadow-[#25D366]/50 transition-all duration-300"
        >
          <MessageCircle size={26} />
          <span className="absolute right-16 bg-white text-navy px-3 py-1.5 rounded-md text-xs font-semibold shadow-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap">
            Chat on WhatsApp
          </span>
        </a>
        <a
          href={LINKEDIN_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="linkedin-float"
          aria-label="LinkedIn"
          className="group w-14 h-14 rounded-full bg-[#0A66C2] text-white flex items-center justify-center shadow-2xl hover:scale-110 hover:shadow-[#0A66C2]/50 transition-all duration-300"
        >
          <Linkedin size={24} />
          <span className="absolute right-16 bg-white text-navy px-3 py-1.5 rounded-md text-xs font-semibold shadow-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap">
            Connect on LinkedIn
          </span>
        </a>
      </div>

      <footer data-testid="footer" className="bg-navy-dark text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
          backgroundImage: `url('https://grainy-gradients.vercel.app/noise.svg')`
        }} />
        <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-gold/5 blur-3xl pointer-events-none" />

        <div className="container mx-auto px-4 md:px-8 max-w-7xl relative z-10">
          {/* Quick Action Bar */}
          <div className="py-10 border-b border-white/10">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <a
                href="#"
                data-testid="footer-download-profile"
                onClick={(e) => { e.preventDefault(); alert('Company Profile PDF will be available soon. Email rudraksh@sawariyaglobalexports.com to request.'); }}
                className="group flex items-center gap-4 bg-white/5 hover:bg-gold hover:text-navy-dark border border-white/10 hover:border-gold rounded-lg p-5 transition-all duration-300"
              >
                <Download className="w-6 h-6 text-gold group-hover:text-navy-dark transition-colors flex-shrink-0" />
                <div>
                  <div className="font-heading font-semibold text-sm">Company Profile</div>
                  <div className="font-body text-xs opacity-70">Download PDF</div>
                </div>
              </a>
              <a
                href="#"
                data-testid="footer-download-catalog"
                onClick={(e) => { e.preventDefault(); alert('Product Catalogue PDF will be available soon. Email rudraksh@sawariyaglobalexports.com to request.'); }}
                className="group flex items-center gap-4 bg-white/5 hover:bg-gold hover:text-navy-dark border border-white/10 hover:border-gold rounded-lg p-5 transition-all duration-300"
              >
                <FileText className="w-6 h-6 text-gold group-hover:text-navy-dark transition-colors flex-shrink-0" />
                <div>
                  <div className="font-heading font-semibold text-sm">Product Catalogue</div>
                  <div className="font-body text-xs opacity-70">Download PDF</div>
                </div>
              </a>
              <Link
                to="/contact?subject=Private+Label+Enquiry"
                data-testid="footer-private-label"
                className="group flex items-center gap-4 bg-white/5 hover:bg-gold hover:text-navy-dark border border-white/10 hover:border-gold rounded-lg p-5 transition-all duration-300"
              >
                <Package className="w-6 h-6 text-gold group-hover:text-navy-dark transition-colors flex-shrink-0" />
                <div>
                  <div className="font-heading font-semibold text-sm">Private Label Enquiry</div>
                  <div className="font-body text-xs opacity-70">Build your brand</div>
                </div>
              </Link>
              <Link
                to="/contact?subject=Export+Enquiry"
                data-testid="footer-export-enquiry"
                className="group flex items-center gap-4 bg-white/5 hover:bg-gold hover:text-navy-dark border border-white/10 hover:border-gold rounded-lg p-5 transition-all duration-300"
              >
                <ArrowRight className="w-6 h-6 text-gold group-hover:text-navy-dark transition-colors flex-shrink-0" />
                <div>
                  <div className="font-heading font-semibold text-sm">Export Enquiry</div>
                  <div className="font-body text-xs opacity-70">Request a quote</div>
                </div>
              </Link>
            </div>
          </div>

          {/* Main Footer Content */}
          <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            <div className="lg:col-span-1">
              <div className="mb-6">
                <div className="logo-spotlight inline-flex">
                  <img src={LOGO_URL} alt="Sawariya Global Exports LLP" className="logo-image h-28 w-auto object-contain" />
                </div>
              </div>
              <p className="font-body text-white/70 leading-relaxed mb-6">
                Premium Indian Basmati Rice exporter from Haryana with 40 years of milling excellence. EU-compliant rice specialists and private-label experts serving 25+ countries.
              </p>
              <div className="w-16 h-0.5 bg-gold mb-4" />
              <div className="flex gap-3">
                <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="w-10 h-10 rounded-full bg-white/5 hover:bg-gold hover:text-navy-dark flex items-center justify-center transition-colors">
                  <Linkedin size={18} />
                </a>
                <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="w-10 h-10 rounded-full bg-white/5 hover:bg-gold hover:text-navy-dark flex items-center justify-center transition-colors">
                  <MessageCircle size={18} />
                </a>
                <a href="mailto:rudraksh@sawariyaglobalexports.com" aria-label="Email" className="w-10 h-10 rounded-full bg-white/5 hover:bg-gold hover:text-navy-dark flex items-center justify-center transition-colors">
                  <Mail size={18} />
                </a>
              </div>
            </div>

            <div className="lg:col-span-1">
              <h4 className="font-heading text-lg font-semibold mb-6 text-gold">Quick Links</h4>
              <ul className="space-y-3">
                {[
                  { path: '/', label: 'Home' },
                  { path: '/about', label: 'About Us' },
                  { path: '/leadership', label: 'Leadership' },
                  { path: '/brands', label: 'Our Brands' },
                  { path: '/products', label: 'Our Products' },
                  { path: '/contact', label: 'Contact Us' },
                ].map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} data-testid={`footer-${link.label.toLowerCase().replace(' ', '-')}`} className="font-body text-white/70 hover:text-gold transition-colors duration-300 flex items-center gap-2 group">
                      <ArrowRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:col-span-1">
              <h4 className="font-heading text-lg font-semibold mb-6 text-gold">Our Products</h4>
              <ul className="space-y-3">
                {[
                  '1121 XXXL Steam',
                  '1121 Golden Sella',
                  '1509 Basmati',
                  'Sugandha Rice',
                  'Sharbati Rice',
                  'Pesticide Free Rice',
                ].map((product) => (
                  <li key={product}>
                    <span className="font-body text-white/70">{product}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:col-span-1">
              <h4 className="font-heading text-lg font-semibold mb-6 text-gold">Contact Us</h4>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <MapPin size={20} className="text-gold flex-shrink-0 mt-1" />
                  <p className="font-body text-white/70">
                    Sawariya Global Exports LLP<br />
                    Pipli Road, District Kurukshetra<br />
                    Haryana - 136132, India
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <Phone size={20} className="text-gold flex-shrink-0" />
                  <a href="tel:+919896557781" className="font-body text-white/70 hover:text-gold transition-colors">+91-9896557781</a>
                </div>
                <div className="flex items-center gap-3">
                  <Mail size={20} className="text-gold flex-shrink-0" />
                  <a href="mailto:rudraksh@sawariyaglobalexports.com" className="font-body text-white/70 hover:text-gold transition-colors text-sm">rudraksh@sawariyaglobalexports.com</a>
                </div>
              </div>
            </div>
          </div>

          {/* Certifications Bar */}
          <div className="border-t border-white/10 py-8">
            <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12">
              <span className="font-body text-xs tracking-widest uppercase text-white/50">Certified By:</span>
              {['APEDA', 'FSSAI', 'USFDA', 'ISO 22000', 'HACCP'].map((cert) => (
                <span key={cert} className="font-body text-sm tracking-wider text-gold/80 border border-gold/30 px-4 py-2 rounded">
                  {cert}
                </span>
              ))}
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-white/10 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="font-body text-sm text-white/50">
              © 2024 Sawariya Global Exports LLP. All rights reserved.
            </p>
            <p className="font-body text-sm text-white/50">
              Premium Indian Basmati Rice Exporters &middot; EU Compliant &middot; Private Label Specialists
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};
